import { message } from 'antd'

import localStorage from 'core/application/commons/localStorage'

import Error from './Error'

/**
 * @deprecated The method should not be used. Please use useQueryRequestV2 instead.
 */
const queryRequest = async (func: () => {}): Promise<any> => {
  try {
    return await func()
  } catch (err) {
    if (!err || !err.status) {
      message.error('There was an error while processing your request')
      return
    }

    if (err.status === 401) {
      window.location.href = '/login'
    } else if (err.status && err.status === 400 && err.data && err.data.length) {
      return {
        errors: err.data.map((err: Error) => err.message),
      }
    } else {
      message.error('There was an error while processing your request')
    }
  }
}

/**
 * @deprecated The method should not be used. Please use useCommandRequestV2 instead.
 */
const commandRequest = async (func: () => {}): Promise<any> => {
  try {
    return await func()
  } catch (err) {
    if (!err || !err.status) {
      return {
        errors: ['There was an error while processing your request'],
      }
    }

    if (err.status === 401 && localStorage.getImpersonatorToken()) {
      return {
        errors: ['You are not allowed to make actions while impersonating'],
      }
    }

    if (err.status === 401) {
      window.location.href = '/login'
    } else if (err.status && err.status === 400 && err.data && err.data.length) {
      return {
        errors: err.data.map((err: Error) => err.message),
      }
    } else {
      return {
        errors: ['There was an error while processing your request'],
      }
    }
  }
}

export { queryRequest, commandRequest }
